// TODO: Remove this export of SVG and instead use Lucid to simplify

export const SkipIcon = ({ width = '30', height = '20' }) => (
  <svg version="1.1" width={width} height={height} x="0" y="0" viewBox="0 0 480 480">
    <g>
      <path
        d="m461.248 194.736-128-128c-24.928-24.96-65.568-24.96-90.496 0C230.656 78.8 224 94.896 224 111.984s6.656 33.184 18.752 45.248l82.752 82.752-82.752 82.752C230.656 334.832 224 350.896 224 367.984s6.656 33.152 18.752 45.248c12.096 12.096 28.16 18.752 45.248 18.752s33.152-6.656 45.248-18.752l128-128C473.344 273.168 480 257.072 480 239.984s-6.656-33.184-18.752-45.248zm-22.624 67.872-128 128c-12.128 12.096-33.12 12.096-45.248 0-12.48-12.48-12.48-32.768 0-45.248l105.376-105.376-105.376-105.376c-6.048-6.048-9.376-14.08-9.376-22.624s3.328-16.576 9.376-22.624A31.912 31.912 0 0 1 288 79.984a32.013 32.013 0 0 1 22.624 9.344l128 128c6.048 6.08 9.376 14.112 9.376 22.656s-3.328 16.576-9.376 22.624z"
        fill="#ffffff"
        opacity="1"
        data-original="#000000"
      ></path>
      <path
        d="m237.248 194.736-128-128c-24.928-24.96-65.568-24.96-90.496 0C6.656 78.8 0 94.896 0 111.984s6.656 33.184 18.752 45.248l82.752 82.752-82.752 82.752C6.656 334.832 0 350.896 0 367.984s6.656 33.152 18.752 45.248c12.096 12.096 28.16 18.752 45.248 18.752s33.152-6.656 45.248-18.752l128-128C249.344 273.168 256 257.072 256 239.984s-6.656-33.184-18.752-45.248zm-22.624 67.872-128 128c-12.128 12.096-33.12 12.096-45.248 0-12.48-12.48-12.48-32.768 0-45.248l105.376-105.376L41.376 134.608C35.328 128.56 32 120.528 32 111.984s3.328-16.576 9.376-22.624c6.24-6.24 14.432-9.376 22.624-9.376s16.384 3.136 22.624 9.344l128 128c6.048 6.08 9.376 14.112 9.376 22.656s-3.328 16.576-9.376 22.624z"
        fill="#ffffff"
        opacity="1"
        data-original="#000000"
      ></path>
    </g>
  </svg>
);

export const ShareIcon = ({ width = '30', height = '20' }) => (
  <svg version="1.1" width={width} height={height} x="0" y="0" viewBox="0 0 32 32">
    <g>
      <path
        d="M9.546 17.704a.9.9 0 0 0-.9-.9H4.845a.9.9 0 0 0 0 1.8h3.801a.9.9 0 0 0 .9-.9zM9.546 14.296a.9.9 0 0 0-.9-.9H2a.9.9 0 0 0 0 1.8h6.646a.9.9 0 0 0 .9-.9z"
        fill="#ffffff"
        opacity="1"
        data-original="#000000"
      ></path>
      <path
        d="M29.387 13.463 12.799 4.496a2.854 2.854 0 0 0-3.305.397 2.855 2.855 0 0 0-.729 3.249l3.098 7.442c.112.269.112.564 0 .833l-3.098 7.441a2.853 2.853 0 0 0 .729 3.249 2.86 2.86 0 0 0 1.925.751c.468 0 .941-.117 1.38-.354l16.587-8.966c.934-.504 1.513-1.477 1.513-2.538s-.579-2.033-1.512-2.537zm-.856 3.491-16.587 8.967c-.627.337-1.111-.03-1.243-.149-.134-.121-.547-.565-.274-1.222l3.097-7.441c.028-.068.041-.14.063-.209h5.516a.9.9 0 0 0 0-1.8h-5.515c-.023-.069-.035-.141-.063-.208L10.427 7.45c-.273-.656.14-1.101.274-1.221.093-.084.357-.289.722-.289.157 0 .332.038.52.139l16.588 8.967c.356.193.569.549.569.954s-.213.761-.569.954z"
        fill="#ffffff"
        opacity="1"
        data-original="#000000"
      ></path>
    </g>
  </svg>
);

export const TickIcon = ({ width = '30', height = '20' }) => (
  <svg version="1.1" width={width} height={height} x="0" y="0" viewBox="0 0 100 100">
    <g>
      <path
        fillRule="evenodd"
        d="M95.338 2.5c-1.432 0-4.068.274-7.915.811-3.847.54-6.334 1.061-7.455 1.556-1.125.493-3.158 2.208-6.093 5.122-2.938 2.926-7.2 8.324-12.773 16.192-5.581 7.877-10.786 16.19-15.625 24.95a352.65 352.65 0 0 0-13.551 27.29c-3.88-6.642-7.385-11.145-10.535-13.513-3.14-2.378-5.79-3.564-7.945-3.564-1.683 0-3.79.897-6.333 2.684-2.54 1.79-3.81 3.544-3.81 5.274 0 1.251 1.165 3.106 3.496 5.559 4.616 4.877 8.702 10.05 12.238 15.524 2.16 3.274 3.597 5.284 4.313 6.017.712.725 2.882 1.098 6.51 1.098 5.048 0 8.047-.647 9-1.95.945-1.253 2.695-4.99 5.245-11.22 6.303-15.598 14.14-30.494 23.507-44.676 9.375-14.175 17.962-24.9 25.78-32.165 1.557-1.38 2.492-2.275 2.821-2.688.32-.415.484-.832.484-1.266 0-.686-.454-1.035-1.359-1.035z"
        clipRule="evenodd"
        fill="#ffffff"
        opacity="1"
        data-original="#000000"
      ></path>
    </g>
  </svg>
);

export const RelaxedIcon = ({ width = '60', height = '60' }) => (
  <svg version="1.1" width={width} height={height} x="0" y="0" viewBox="0 0 511.991 511.991">
    <g>
      <path
        d="M461.292 425.682c-13.856-1.23-28 2.515-40.283 10.408l-45.081-65.182s78.873-.111 79.203-.113c22.377-.658 40.048-19.398 39.391-41.775l-1.259-42.84c-.311-10.57-6.601-20.231-16.384-24.243-9.732-3.991-20.524-1.984-28.177 5.252-9.955 9.411-16.491 22.23-18.823 36.401a2637.485 2637.485 0 0 1-26.026-4.461c-5.245-.922-10.518 2.231-11.779 7.405-1.382 5.671 2.322 11.239 7.979 12.234 8.351 1.469 18.713 3.272 29.079 4.969l.806 27.443-204.602-.758c-29.427 0-53.938-21.451-58.71-49.53h111.36c7.572 0 18.189.938 32.461 2.866.454.061.905.091 1.352.091 5.037 0 9.408-3.807 9.937-8.997.553-5.43-3.564-10.235-8.974-10.963-10.735-1.444-19.608-2.354-26.875-2.756l-18.56-75.588c-1.589-6.462-3.945-13.076-6.928-19.646 7.241-10.891 36.232-54.468 36.232-54.468 8.588-12.907 10.806-28.779 6.085-43.546-4.724-14.773-15.742-26.42-30.233-31.955L193.12 25.631C177.676 4.55 149.925-5.404 123.683 2.952c-28.31 9.014-45.735 36.427-43.327 64.859l-51.005 60.736c-9.878 11.754-13.877 27.144-10.975 42.219 3.212 16.734 15.385 31.11 31.769 37.518l26.432 10.335.001 283.371c0 5.523 4.478 10 10 10h40.736c5.523 0 10-4.477 10-10v-90.834h90.899v90.834c0 5.523 4.477 10 10 10h40.736c5.523 0 10-4.477 10-10V386.381c11.047 12.528 99.048 112.809 99.048 112.809 7.425 7.904 17.484 12.443 28.324 12.78.434.014.865.021 1.297.021 10.363 0 20.181-3.883 27.768-11.012l31.671-29.757c7.685-7.219 10.318-17.892 6.874-27.855-3.446-9.974-12.121-16.751-22.639-17.685zm1.15-143.961c2.732-2.582 5.713-1.75 6.868-1.272 1.149.476 3.834 1.984 3.943 5.719l1.276 43.439c.334 11.354-8.632 20.863-19.986 21.197l-4.603.135-1-34.045v.001c-.401-13.653 4.646-26.802 13.502-35.174zM268.95 370.42v20.736H96.578V370.42zm-96.283-20h-35.351v-92.823l6.729 27.411a79.742 79.742 0 0 1 2.034 12.463c1.731 21.015 11.661 39.734 26.588 52.949zM283.665 93.973c2.86 8.945 1.517 18.559-3.685 26.379 0 0-25.186 37.86-30.527 45.891a146.156 146.156 0 0 0-13.415-17.239 134.152 134.152 0 0 0-7.886-7.971 57749.584 57749.584 0 0 1 21.993-30.735c1.188-1.658 1.959-3.612 2.029-5.65a10.017 10.017 0 0 0-5.917-9.527c-7.941-3.549-34.768-15.556-34.768-15.556a62.392 62.392 0 0 0-2.872-15.974l-3.854-12.107 60.585 23.128c8.779 3.353 15.456 10.41 18.317 19.361zm-74.707 6.37 17.961 8.039c-4.833 6.752-9.66 13.502-14.488 20.251-4.64-3.028-9.361-5.585-14.109-7.636a63.04 63.04 0 0 0 10.636-20.654zm-79.207-78.334A42.355 42.355 0 0 1 142.627 20c18.027 0 34.804 11.562 40.559 29.634l6.375 20.023c7.114 22.348-5.278 46.318-27.626 53.434s-46.317-5.277-53.435-27.625l-6.375-20.023c-7.114-22.348 5.279-46.318 27.626-53.434zm-19.556 109.534a63.037 63.037 0 0 0 15.074 8.833 56.376 56.376 0 0 0-2.498 4.466c-2.37 4.772-6.374 8.281-11.307 9.924-5.107 1.702-10.717.971-15.406-1.673l-1.396-.787zM38.016 166.99c-1.758-9.135.664-18.457 6.649-25.578L86.34 91.785l3.104 9.749a62.366 62.366 0 0 0 7.05 14.936l-24.665 32.971a10 10 0 0 0 3.099 14.702c8.933 5.122 19.986 12.235 30.583 11.608a38.778 38.778 0 0 0 11.385-1.725c10.282-3.159 18.953-10.553 23.776-20.263a35.067 35.067 0 0 1 2.667-4.492 34.094 34.094 0 0 1 3.493-4.213 61.85 61.85 0 0 0 2.24.045c6.269 0 12.646-.952 18.932-2.953a62.481 62.481 0 0 0 13.102-5.918c30.57 7.192 59.385 43.919 66.8 74.084l17.329 70.575H163.629l-12.26-49.944a10.002 10.002 0 0 0-6.07-6.929L57.43 189.659c-10.045-3.93-17.483-12.614-19.414-22.669zm79.301 67.56v115.87h-20.74V226.44zm-.003 257.44H96.578v-80.834h20.736zm130.899 0v-80.834h20.736v80.834zm53.421-121.455 49.893.251 54.04 78.137-19.773 18.577c-13.276-14.617-72.43-83.73-84.16-96.965zm161.73 86.111-31.672 29.757a20.444 20.444 0 0 1-14.712 5.578c-5.63-.166-10.915-2.77-14.772-6.875l-2.787-2.966 24.822-23.321v-.001c9.953-9.352 23.137-14.289 35.281-13.214 3.744.333 5.098 3.116 5.506 4.297.406 1.176 1.057 4.186-1.666 6.745z"
        fill="#009f25"
        opacity="1"
        data-original="#000000"
      ></path>
      <path
        d="M355.092 310.84a10.012 10.012 0 0 0 11.555-11.554c-.68-4.145-4.022-7.487-8.167-8.168a10.012 10.012 0 0 0-11.555 11.555c.68 4.145 4.023 7.487 8.167 8.167z"
        fill="#009f25"
        opacity="1"
        data-original="#000000"
      ></path>
    </g>
  </svg>
);

export const PersonalityIcon = ({ width = '60', height = '60' }) => (
  <svg version="1.1" width={width} height={height} x="0" y="0" viewBox="0 0 56 56">
    <g>
      <path
        d="M43.297 51.04a1 1 0 0 1-1-1l.001-9.975c0-2.095.609-4.087 1.761-5.762a17.381 17.381 0 0 0 3.066-9.892c0-9.623-7.869-17.452-17.542-17.452-2.572 0-5.07.563-7.425 1.673-5.536 2.655-9.335 8.042-9.909 14.056a18.004 18.004 0 0 0-.079 2.099c.038 1.82-.346 3.697-1.141 5.581l-2.127 5.036a.336.336 0 0 0 .223.455l2.532.703a2.335 2.335 0 0 1 1.694 1.957l1.091 6.802c.008.052.013.104.013.156a1.816 1.816 0 0 0 1.813 1.809h6.345a4.422 4.422 0 0 0 4.417-4.417 1 1 0 1 1 2 0 6.424 6.424 0 0 1-6.417 6.417h-6.345a3.82 3.82 0 0 1-3.812-3.72l-1.084-6.762c-.022-.167-.119-.278-.25-.315l-2.532-.701a2.336 2.336 0 0 1-1.529-3.162l2.126-5.035c.686-1.623 1.017-3.224.984-4.76-.016-.771.013-1.556.087-2.333C10.899 15.79 15.13 9.786 21.3 6.827a19.28 19.28 0 0 1 8.284-1.867c10.775 0 19.542 8.726 19.542 19.452a19.38 19.38 0 0 1-3.418 11.026c-.922 1.34-1.409 2.939-1.409 4.628l-.001 9.975a1.001 1.001 0 0 1-1.001.999z"
        fill="#009f25"
        opacity="1"
        data-original="#000000"
      ></path>
      <path
        d="M39.432 23.945a1 1 0 0 1-.847-1.529 4.134 4.134 0 0 0 .626-2.189 4.146 4.146 0 0 0-4.776-4.093.995.995 0 0 1-1.066-.582c-.807-1.814-2.575-2.986-4.505-2.986a4.933 4.933 0 0 0-4.889 5.549 1 1 0 1 1-1.984.25 6.936 6.936 0 0 1 6.874-7.799c2.479 0 4.764 1.361 6.003 3.523a6.148 6.148 0 0 1 6.344 6.138 6.126 6.126 0 0 1-.929 3.248c-.191.304-.517.47-.851.47z"
        fill="#009f25"
        opacity="1"
        data-original="#000000"
      ></path>
      <path
        d="M22.24 27.804c-3.386 0-6.141-2.755-6.141-6.141a6.148 6.148 0 0 1 6.456-6.133.999.999 0 0 1 .949 1.048.992.992 0 0 1-1.048.949 4.146 4.146 0 0 0-4.356 4.136 4.145 4.145 0 0 0 4.141 4.141 1 1 0 1 1-.001 2zM38.172 30.629c-2.9 0-5.261-2.36-5.261-5.261a1 1 0 1 1 2 0c0 1.798 1.463 3.261 3.261 3.261s3.261-1.463 3.261-3.261a3.28 3.28 0 0 0-1.598-2.806 1 1 0 1 1 1.023-1.719 5.29 5.29 0 0 1 2.574 4.524 5.266 5.266 0 0 1-5.26 5.262z"
        fill="#009f25"
        opacity="1"
        data-original="#000000"
      ></path>
      <path
        d="M32.876 26.25a3.933 3.933 0 0 1-3.172-1.598 1 1 0 1 1 1.609-1.187 1.937 1.937 0 0 0 2.704.41c.601-.442.89-1.173.756-1.906a1 1 0 1 1 1.967-.36 3.907 3.907 0 0 1-1.535 3.875 3.917 3.917 0 0 1-2.329.766zM32.057 21.703a1 1 0 0 1-.989-1.15 1.925 1.925 0 0 0-.355-1.437 1.922 1.922 0 0 0-1.268-.765 1.919 1.919 0 0 0-1.881.813 1 1 0 1 1-1.645-1.137 3.916 3.916 0 0 1 3.826-1.654 3.91 3.91 0 0 1 2.579 1.555c.623.846.88 1.884.722 2.923a1.003 1.003 0 0 1-.989.852zM31.864 37.443a1 1 0 0 1-1-1v-2.85a2.452 2.452 0 0 0-2.449-2.449h-2.167c-2.378 0-4.313-1.935-4.313-4.313s1.935-4.313 4.313-4.313a1 1 0 0 1 0 2c-1.275 0-2.313 1.038-2.313 2.313s1.038 2.313 2.313 2.313h2.167a4.454 4.454 0 0 1 4.449 4.449v2.85a1 1 0 0 1-1 1z"
        fill="#009f25"
        opacity="1"
        data-original="#000000"
      ></path>
    </g>
  </svg>
);

export const Subtitles = ({ width = '30', height = '20' }) => (
  <svg version="1.1" width={width} height={height} x="0" y="0" viewBox="0 0 24 24">
    <g>
      <path
        fill="#ffffff"
        d="M19.5 5.5v13h-15v-13zM19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1z"
        opacity="1"
        data-original="#000000"
      ></path>
    </g>
  </svg>
);

export const SubtitlesOff = ({ width = '30', height = '20' }) => (
  <svg version="1.1" width={width} height={height} x="0" y="0" viewBox="0 0 24 24">
    <g>
      <clipPath id="a">
        <path d="M0 0h24v24H0z" fill="#ffffff" opacity="1" data-original="#000000"></path>
      </clipPath>
      <g clipPath="url(#a)">
        <path
          fill="#ffffff"
          d="M13 10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1h-1.5v-.5h-2v1zm3.5 3.5 1.21 1.21c.18-.19.29-.44.29-.71v-1h-1.5zM8.83 6H19v10.17l1.98 1.98c0-.05.02-.1.02-.16V6c0-1.1-.9-2-2-2H6.83zm10.95 16.61L17.17 20H5a2 2 0 0 1-2-2V6c0-.05.02-.1.02-.15L1.39 4.22 2.8 2.81l18.38 18.38zM7.5 13.5h2V13h.67l-2.5-2.5H7.5zm7.67 4.5L11 13.83V14c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.32.16-.59.4-.78L5 7.83V18z"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </g>
  </svg>
);

export const CallVideoOff = ({ width = '28', height = '28' }) => (
  <svg version="1.1" width={width} height={height} x="0" y="0" viewBox="0 0 24 24">
    <g>
      <path
        d="M2.7 18.26a.743.743 0 0 1-.481-.175A2.708 2.708 0 0 1 1.25 16V8A2.754 2.754 0 0 1 4 5.25h6.76a.75.75 0 0 1 0 1.5H4A1.252 1.252 0 0 0 2.75 8v8a1.212 1.212 0 0 0 .432.935.75.75 0 0 1-.482 1.325zM14 18.75H4.8a.75.75 0 0 1 0-1.5H14A1.252 1.252 0 0 0 15.25 16V8A1.269 1.269 0 0 0 14 6.75h-.8a.75.75 0 0 1 0-1.5h.8A2.77 2.77 0 0 1 16.75 8v8A2.753 2.753 0 0 1 14 18.75z"
        fill="#ffffff"
        opacity="1"
        data-original="#000000"
      ></path>
      <path
        d="M22 16.75a.775.775 0 0 1-.185-.023l-6-1.53a.75.75 0 0 1-.565-.727V9.53a.75.75 0 0 1 .565-.727l6-1.53A.751.751 0 0 1 22.75 8v8a.751.751 0 0 1-.75.75zm-5.25-2.863 4.5 1.148v-6.07l-4.5 1.148zM2 22.75a.75.75 0 0 1-.614-1.18l14-20a.75.75 0 1 1 1.228.86l-14 20a.745.745 0 0 1-.614.32z"
        fill="#ffffff"
        opacity="1"
        data-original="#000000"
      ></path>
    </g>
  </svg>
);

export const CallVideoOn = ({ width = '28', height = '28' }) => (
  <svg version="1.1" width={width} height={height} x="0" y="0" viewBox="0 0 24 24">
    <g>
      <path
        d="M21.789 6.341a1.508 1.508 0 0 0-1.528-.024L16.5 9.024V8A2.503 2.503 0 0 0 14 5.5H4A2.503 2.503 0 0 0 1.5 8v8A2.503 2.503 0 0 0 4 18.5h10a2.503 2.503 0 0 0 2.5-2.5v-1.026l3.83 2.75a1.5 1.5 0 0 0 2.17-1.343V7.617a1.491 1.491 0 0 0-.711-1.276ZM15.5 16a1.502 1.502 0 0 1-1.5 1.5H4A1.502 1.502 0 0 1 2.5 16V8A1.502 1.502 0 0 1 4 6.5h10A1.502 1.502 0 0 1 15.5 8Zm6 .381a.517.517 0 0 1-.655.49L16.5 13.743v-3.488l4.276-3.086a.5.5 0 0 1 .724.447Z"
        fill="#ffffff"
        opacity="1"
        data-original="#000000"
      ></path>
    </g>
  </svg>
);

export const RecordingCamera = ({ width = '20', height = '20' }) => (
  <svg width={width} height={height} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
    />
  </svg>
);

export const RecordingMicrophone = ({ width = '20', height = '20' }) => (
  <svg width={width} height={height} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
    />
  </svg>
);

export const RecordingChevronDown = ({ width = '12', height = '12' }) => (
  <svg className="ml-1" width={width} height={height} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
);

export const RecordingTryAgain = ({ width = '16', height = '16' }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 12a9 9 0 11-9-9M21 3v9h-9" />
  </svg>
);

export const Arrow = ({ width = '18', height = '16' }) => (
  <svg width={width} height={height} viewBox="0 0 18 16" fill="none">
    <path
      d="M1.39095 8.36055C1.34141 8.36517 1.29145 8.35926 1.24426 8.34319C1.19707 8.32713 1.15369 8.30126 1.1169 8.26725C1.0801 8.23324 1.0507 8.19182 1.03057 8.14566C1.01045 8.0995 1.00003 8.0496 1 7.99915C0.999966 7.9487 1.01031 7.89881 1.03038 7.85268C1.05045 7.80654 1.07979 7.76517 1.11654 7.73121C1.15329 7.69724 1.19663 7.67144 1.2438 7.65544C1.29097 7.63943 1.34092 7.63359 1.39047 7.63827L15.6255 7.64671L9.68997 1.62895C9.62176 1.55979 9.5834 1.46603 9.58333 1.36829C9.58327 1.27055 9.6215 1.17683 9.68963 1.10777C9.75775 1.0387 9.85018 0.999934 9.94659 1C10.043 1.00007 10.1355 1.03896 10.2037 1.10812L17 7.99861L10.2006 14.8922C10.1325 14.9613 10.04 15.0001 9.94364 15C9.84723 14.9999 9.75475 14.961 9.68653 14.8919C9.61832 14.8227 9.57996 14.729 9.57989 14.6312C9.57983 14.5335 9.61806 14.4398 9.68619 14.3707L15.6137 8.36103L1.39095 8.36055Z"
      fill="#009F25"
      stroke="#009F25"
      strokeLinecap="round"
    />
  </svg>
);

export const UploadFileIcon = ({ width = '48', height = '48' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="0.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-file"
  >
    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
  </svg>
);

export const UploadAudioIcon = ({ width = '512', height = '512' }) => (
  <svg version="1.1" width={width} height={height} x="0" y="0" viewBox="0 0 407.4 407.4">
    <g>
      <path
        d="M273.6 176.6c-2.1-2-5-2.8-7.8-2.1l-95.6 19.3c-4.9 1-8.4 5.4-8.3 10.4v74.2a32.5 32.5 0 0 0-11.5-2.1c-18.2-.3-33.1 14.2-33.4 32.4-.3 18.2 14.2 33.1 32.4 33.4 18.2.3 33.1-14.2 33.4-32.4v-56.9l73.1-15.2v21.9c0-1-6.8-2.1-11-2.1-17.9.3-32.2 15-31.9 32.9.3 18 14.9 32.4 32.9 32.4 18.3-.6 31.1-15.7 30.8-34V184.4c.3-3-.8-5.9-3.1-7.8zM151.4 321.1c-.1-.1-.3-.1-.5 0-6.6.7-12.8-3.1-14.2-9.6-1.4-6.5 2.8-12.9 9.3-14.2 1.6-.3 3.4-.7 5-.5 6.3.7 11.4 5.6 11.4 12 .3 6.3-4.7 12-11 12.3zm31.4-89.7v-18.8l73.1-15.2v18.8l-73.1 15.2zm64.2 70.5h-1c-6.3 0-11.5-5.1-11.5-11.5-.3-6.6 4.9-12.2 11.5-12.5 6.6-.3 12.2 4.9 12.5 11.5.3 6.6-4.9 12.2-11.5 12.5z"
        fill="#009f25"
        opacity="1"
        data-original="#000000"
      ></path>
      <path
        d="M362.5 113.3 251.8 3.1c-1.9-2-4.6-3.1-7.3-3.1H94C65.1 0 41.8 23.4 41.8 52.2v303c0 28.9 23.4 52.2 52.2 52.2h219.4c28.9 0 52.2-23.4 52.2-52.2V120.6c0-2.8-1.2-5.4-3.1-7.3zM256 104.4V36.599l73.6 73.001h-68.4c-2.6.3-4.9-1.5-5.2-4.1v-1.1zm88.8 250.8c0 17.3-14 31.3-31.3 31.3H94c-17.3 0-31.3-14-31.3-31.3v-303c0-17.3 14-31.3 31.3-31.3h141.1v83.6c0 14.4 11.7 26.1 26.1 26.1h83.6v224.6z"
        fill="#009f25"
        opacity="1"
        data-original="#000000"
      ></path>
    </g>
  </svg>
);

export const UploadVideoIcon = ({ width = '48', height = '48' }) => (
  <svg version="1.1" width={width} height={height} x="0" y="0" viewBox="0 0 32 32">
    <g>
      <g data-name="33-Video-file">
        <path
          d="m26.71 9.29-7-7A1 1 0 0 0 19 2H8a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V10a1 1 0 0 0-.29-.71zM20 5.41 23.59 9H21a1 1 0 0 1-1-1zM24 28H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10v4a3 3 0 0 0 3 3h4v16a1 1 0 0 1-1 1z"
          fill="#009f25"
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="m20.17 15.5-5.11-3.19A2 2 0 0 0 12 14v6.39a2 2 0 0 0 3.06 1.7l5.11-3.2a2 2 0 0 0 0-3.39zM14 20.39V14l5.11 3.2z"
          fill="#009f25"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </g>
  </svg>
);
export const UploadCircleAddIcon = ({ width = '24', height = '24' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#009f25"
    strokeWidth="0.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-circle-plus"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M8 12h8" />
    <path d="M12 8v8" />
  </svg>
);

export const RotateMobileSVG = ({ width = '24', height = '24' }) => (
  <svg width={width} height={height} x="0" y="0" viewBox="0 0 64 64">
    <g>
      <path
        d="M43.127 7.133H20.931a4.009 4.009 0 0 0-4.005 4.004v41.726a4.009 4.009 0 0 0 4.005 4.004h22.196a4.009 4.009 0 0 0 4.004-4.004V11.137a4.009 4.009 0 0 0-4.004-4.004zm-6.53 2.002-.767 1.533h-7.602l-.767-1.533zm8.532 43.728a2.004 2.004 0 0 1-2.002 2.002H20.931a2.004 2.004 0 0 1-2.003-2.002V11.137a2.004 2.004 0 0 1 2.003-2.002h4.292l1.49 2.982a1 1 0 0 0 .896.554h8.84a1 1 0 0 0 .895-.554l1.491-2.982h4.292a2.004 2.004 0 0 1 2.002 2.002zM51.572 10.022a1.008 1.008 0 0 0-1.742.673v7.204a1.001 1.001 0 0 0 2.002 0v-4.434c8.866 11.312 8.111 28.68-1.742 39.179a1.001 1.001 0 0 0 1.482 1.346c11.234-11.944 11.24-32.022 0-43.968zM13.227 45.1a1.001 1.001 0 0 0-1.001 1.001v4.434a30.723 30.723 0 0 1 1.742-39.179 1.001 1.001 0 0 0-1.482-1.346 32.72 32.72 0 0 0 0 43.968 1.001 1.001 0 0 0 1.742-.673v-7.204a1.001 1.001 0 0 0-1.001-1z"
        fill="#009f25"
        opacity="1"
        data-original="#000000"
      ></path>
    </g>
  </svg>
);

export const RotateMobile2SVG = ({ width = '160', height = '81' }) => (
  <svg width={width} height={height} viewBox="0 0 160 81" fill="none">
    <path
      d="M160 72.7029L160 46.2971C159.998 44.3625 159.22 42.5078 157.838 41.1398C156.455 39.7718 154.58 39.0022 152.625 39L86.3746 39C84.4193 39.0022 82.5448 39.7718 81.1623 41.1398C79.7798 42.5078 79.0021 44.3625 79 46.2971L79 72.7029C79.0021 74.6375 79.7798 76.4922 81.1623 77.8602C82.5448 79.2282 84.4193 79.9978 86.3746 80L152.625 80C154.58 79.9978 156.455 79.2282 157.838 77.8602C159.22 76.4922 159.998 74.6375 160 72.7029ZM86.3746 76.9304C85.2419 76.929 84.156 76.4832 83.355 75.6907C82.5541 74.8981 82.1036 73.8236 82.1024 72.7029L82.1024 46.2971C82.1036 45.1763 82.5541 44.1018 83.355 43.3093C84.156 42.5168 85.2419 42.0709 86.3746 42.0696L152.625 42.0696C153.758 42.0709 154.844 42.5167 155.645 43.3093C156.446 44.1018 156.896 45.1763 156.898 46.2971L156.898 49.6684L155.595 49.6684C154.659 49.6694 153.761 50.0378 153.099 50.6928C152.437 51.3477 152.065 52.2357 152.064 53.1619L152.064 65.9191C152.065 66.8453 152.437 67.7333 153.099 68.3883C153.761 69.0432 154.659 69.4117 155.595 69.4127L156.898 69.4127L156.898 72.7029C156.896 73.8237 156.446 74.8982 155.645 75.6907C154.844 76.4833 153.758 76.9291 152.625 76.9304L86.3746 76.9304Z"
      fill="#00B229"
    />
    <path
      opacity="0.5"
      d="M33.7029 0L7.2971 0C5.3625 0.00219141 3.50775 0.77987 2.13976 2.16243C0.771765 3.54498 0.00223908 5.41951 0 7.37478L0 73.6254C0.00223917 75.5807 0.771771 77.4552 2.13977 78.8377C3.50777 80.2202 5.36252 80.9979 7.2971 81H33.7029C35.6375 80.9979 37.4922 80.2202 38.8602 78.8377C40.2282 77.4552 40.9978 75.5807 41 73.6254L41 7.37478C40.9978 5.41951 40.2282 3.54498 38.8602 2.16243C37.4922 0.77987 35.6375 0.00219141 33.7029 0ZM37.9304 73.6254C37.9291 74.7581 37.4832 75.844 36.6907 76.645C35.8981 77.4459 34.8236 77.8964 33.7029 77.8976H7.2971C6.17635 77.8964 5.10185 77.4459 4.30932 76.645C3.51678 75.844 3.07094 74.7581 3.0696 73.6254L3.0696 7.37478C3.07089 6.24203 3.51672 5.15605 4.30925 4.3551C5.10179 3.55414 6.17632 3.10363 7.2971 3.10239L10.6684 3.10239V4.40514C10.6694 5.34124 11.0378 6.2387 11.6928 6.90063C12.3477 7.56255 13.2357 7.93488 14.1619 7.93593L26.9191 7.93593C27.8453 7.93491 28.7333 7.56259 29.3883 6.90067C30.0432 6.23874 30.4117 5.34127 30.4127 4.40514V3.10239L33.7029 3.10239C34.8237 3.10363 35.8982 3.55414 36.6907 4.3551C37.4833 5.15605 37.9291 6.24203 37.9304 7.37478L37.9304 73.6254Z"
      fill="#00B229"
    />
    <path
      d="M81.6833 15.9961V27.9961M81.6833 27.9961H69.6833M81.6833 27.9961L72.4233 19.2761C69.6645 16.5156 66.0833 14.7265 62.2192 14.1784C58.3552 13.6303 54.4176 14.353 51 16.2374"
      stroke="#00B229"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RotateMobile3SVG = ({ width = '160', height = '81' }) => (
  <svg width={width} height={height} viewBox="0 0 164 81" fill="none">
    <path
      opacity="0.5"
      d="M4.01903e-07 46.2971L8.7017e-08 72.7029C0.00219148 74.6375 0.77987 76.4922 2.16243 77.8602C3.54498 79.2282 5.41951 79.9978 7.37478 80L73.6254 80C75.5807 79.9978 77.4552 79.2282 78.8377 77.8602C80.2202 76.4922 80.9979 74.6375 81 72.7029L81 46.2971C80.9979 44.3625 80.2202 42.5078 78.8377 41.1398C77.4552 39.7718 75.5807 39.0022 73.6254 39L7.37478 39C5.41951 39.0022 3.54498 39.7718 2.16243 41.1398C0.77987 42.5078 0.00219184 44.3625 4.01903e-07 46.2971ZM73.6254 42.0696C74.7581 42.071 75.844 42.5168 76.645 43.3093C77.4459 44.1019 77.8964 45.1764 77.8976 46.2971L77.8976 72.7029C77.8964 73.8237 77.4459 74.8982 76.645 75.6907C75.844 76.4832 74.7581 76.9291 73.6254 76.9304L7.37478 76.9304C6.24203 76.9291 5.15605 76.4833 4.3551 75.6907C3.55414 74.8982 3.10363 73.8237 3.10239 72.7029L3.10239 69.3316L4.40514 69.3316C5.34124 69.3306 6.2387 68.9622 6.90063 68.3072C7.56255 67.6523 7.93488 66.7643 7.93593 65.8381L7.93593 53.0809C7.93491 52.1547 7.56259 51.2667 6.90067 50.6117C6.23874 49.9568 5.34127 49.5883 4.40514 49.5873L3.10239 49.5873L3.10239 46.2971C3.10363 45.1763 3.55414 44.1018 4.3551 43.3093C5.15605 42.5167 6.24203 42.0709 7.37478 42.0696L73.6254 42.0696Z"
      fill="#00B229"
    />
    <path
      d="M156.703 0L130.297 0C128.362 0.00219141 126.508 0.77987 125.14 2.16243C123.772 3.54498 123.002 5.41951 123 7.37478L123 73.6254C123.002 75.5807 123.772 77.4552 125.14 78.8377C126.508 80.2202 128.363 80.9979 130.297 81H156.703C158.637 80.9979 160.492 80.2202 161.86 78.8377C163.228 77.4552 163.998 75.5807 164 73.6254V7.37478C163.998 5.41951 163.228 3.54498 161.86 2.16243C160.492 0.77987 158.637 0.00219141 156.703 0ZM160.93 73.6254C160.929 74.7581 160.483 75.844 159.691 76.645C158.898 77.4459 157.824 77.8964 156.703 77.8976H130.297C129.176 77.8964 128.102 77.4459 127.309 76.645C126.517 75.844 126.071 74.7581 126.07 73.6254L126.07 7.37478C126.071 6.24203 126.517 5.15605 127.309 4.3551C128.102 3.55414 129.176 3.10363 130.297 3.10239L133.668 3.10239V4.40514C133.669 5.34124 134.038 6.2387 134.693 6.90063C135.348 7.56255 136.236 7.93488 137.162 7.93593L149.919 7.93593C150.845 7.93491 151.733 7.56259 152.388 6.90067C153.043 6.23874 153.412 5.34127 153.413 4.40514V3.10239L156.703 3.10239C157.824 3.10363 158.898 3.55414 159.691 4.3551C160.483 5.15605 160.929 6.24203 160.93 7.37478V73.6254Z"
      fill="#00B229"
    />
    <path
      d="M103.653 6.61293L112.138 15.0982M112.138 15.0982L103.653 23.5835M112.138 15.0982L99.4245 15.48C95.5218 15.4788 91.7244 16.7461 88.6045 19.0908C85.4846 21.4355 83.2114 24.7308 82.1272 28.4799"
      stroke="#00B229"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IntercomSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 32">
    <path d="M28 32s-4.714-1.855-8.527-3.34H3.437C1.54 28.66 0 27.026 0 25.013V3.644C0 1.633 1.54 0 3.437 0h21.125c1.898 0 3.437 1.632 3.437 3.645v18.404H28V32zm-4.139-11.982a.88.88 0 00-1.292-.105c-.03.026-3.015 2.681-8.57 2.681-5.486 0-8.517-2.636-8.571-2.684a.88.88 0 00-1.29.107 1.01 1.01 0 00-.219.708.992.992 0 00.318.664c.142.128 3.537 3.15 9.762 3.15 6.226 0 9.621-3.022 9.763-3.15a.992.992 0 00.317-.664 1.01 1.01 0 00-.218-.707z"></path>
  </svg>
);

export const ScrollArrowDownSVG = ({ width = '34', height = '34' }) => (
  <svg version="1.1" width={width} height={height} x="0" y="0" viewBox="0 0 2.54 2.54" fillRule="evenodd">
    <g>
      <circle
        r="2.17"
        fill="#009f25"
        transform="rotate(-90 1.27 0) scale(.585)"
        opacity="1"
        data-original="#00ba00"
      ></circle>
      <path
        fill="#ffffff"
        d="M1.29 2.243.5 1.455a.17.17 0 0 1 0-.24.17.17 0 0 1 .24 0l.38.38V.461a.17.17 0 0 1 .17-.169.17.17 0 0 1 .168.17v1.133l.38-.38a.17.17 0 0 1 .24 0 .17.17 0 0 1 0 .24l-.55.549-.239.24z"
        opacity="1"
        data-original="#ffffff"
      ></path>
    </g>
  </svg>
);

export const AudioBars = () => {
  return (
    <div className="flex justify-between h-12 w-[160px]">
      <div className="w-1.5 bg-[var(--lifexlight)] rounded animate-quiet"></div>
      <div className="w-1.5 bg-[var(--lifexlight)] rounded animate-normal"></div>
      <div className="w-1.5 bg-[var(--lifexlight)] rounded animate-quiet"></div>
      <div className="w-1.5 bg-[var(--lifexlight)] rounded animate-loud"></div>
      <div className="w-1.5 bg-[var(--lifexlight)] rounded animate-quiet"></div>
      <div className="w-1.5 bg-[var(--lifexlight)] rounded animate-normal"></div>
      <div className="w-1.5 bg-[var(--lifexlight)] rounded animate-quiet"></div>
      <div className="w-1.5 bg-[var(--lifexlight)] rounded animate-loud"></div>
      <div className="w-1.5 bg-[var(--lifexlight)] rounded animate-quiet"></div>
      <div className="w-1.5 bg-[var(--lifexlight)] rounded animate-normal"></div>
    </div>
  );
};
